"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThreeDimensionalIcon;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("./shared/icon-base"));
var _core = require("@emotion/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ThreeDimensionalIcon(props) {
  return (0, _core.jsx)(_iconBase.default, props, (0, _core.jsx)("path", {
    d: "M19.5 11.11C21.7044 12.2901 23 13.968 23 15.8115H21C21 14.981 20.4472 14.1652 19.5 13.4617V11.11V11.11ZM17.3262 19.2975C15.7629 19.8824 13.9385 20.2021 12 20.2021C6.69629 20.2021 3 17.8887 3 15.8115C3 14.981 3.5528 14.1652 4.5 13.4617V11.11C2.29559 12.2901 1 13.968 1 15.8115C1 19.3955 5.83203 22.2022 12 22.2022C14.3012 22.2022 16.49 21.8044 18.3436 21.0582L19.4316 22.9414L22.5491 17.5454H16.314L17.3262 19.2975V19.2975ZM18 6.08789L13.8486 2.83984C12.7588 1.99023 11.2392 1.99023 10.1514 2.83984L5.99999 6.08789V15H7.99999V7.06249L11.3838 4.41601C11.7471 4.13085 12.2529 4.13085 12.6162 4.41601L16 7.06249V15H18V6.08788L18 6.08789ZM13 11H11V15H13V11Z",
    fill: "currentColor"
  }));
}